var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCalendarWithDates = function SvgCalendarWithDates(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 4c.3 0 .5.2.5.5V6h6V4.5c0-.3.2-.5.5-.5s.5.2.5.5V6h2.5c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5h-13c-.8 0-1.5-.7-1.5-1.5v-11C4 6.7 4.7 6 5.5 6H8V4.5c0-.3.2-.5.5-.5M15 8c0 .3.2.5.5.5s.5-.2.5-.5V7h2.5c.3 0 .5.2.5.5v11c0 .3-.2.5-.5.5h-13c-.3 0-.5-.2-.5-.5v-11c0-.3.2-.5.5-.5H8v1c0 .3.2.5.5.5S9 8.3 9 8V7h6zm-8 5.5c0-.3.2-.5.5-.5H10v-2.5c0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5h-9c-.3 0-.5-.2-.5-.5zm9-.5v-2h-2v2zm-2 1h2v2h-2zm-1-1v-2h-2v2zm-2 1h2v2h-2zm-3 2v-2h2v2z",
    clipRule: "evenodd"
  })));
};
export { SvgCalendarWithDates as ReactComponent };
export default __webpack_public_path__ + "static/media/calendarWithDates.cba02a3a7e684ceaaac26ab5d84c35bd.svg";